module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.canImpersonate) ? _c('div', {
    staticClass: "mr-8"
  }, [(!_vm.textFieldActive) ? _c('v-btn', {
    attrs: {
      "loading": _vm.loading
    },
    on: {
      "click": _vm.activateImpersonate
    }
  }, [_vm._v(_vm._s(_vm.$t('Toolbar.virtualAccess')))]) : _vm._e(), _vm._v(" "), (_vm.textFieldActive) ? _c('v-autocomplete', {
    attrs: {
      "items": _vm.items,
      "item-text": "label",
      "item-value": "id",
      "text": "",
      "clearable": "",
      "hide-no-data": "",
      "hide-details": "",
      "label": "Usuario",
      "solo-inverted": ""
    },
    on: {
      "blur": function($event) {
        _vm.textFieldActive = false
      }
    },
    model: {
      value: (_vm.userSelected),
      callback: function($$v) {
        _vm.userSelected = $$v
      },
      expression: "userSelected"
    }
  }) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f40cf7c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shared/ImpersonateBtn.vue
// module id = 888
// module chunks = 0 1